import TableMedicalCompany from "~/components/tables/TableMedicalCompany"

const Requests = () => {
  return <TableMedicalCompany />
}

export default Requests;